import { ReactNode } from 'react'

import styles from './Toast.module.css'

type Props = {
	children: ReactNode
}

export default function Toast({ children, ...props }: Props): JSX.Element {
	return (
		<div className={styles.toast} {...props}>
			{children}
		</div>
	)
}
